import { ApiPagination } from '../interfaces/pagination.interface';

export const convertPaginationToGet = (page?: number, limit?: number): ApiPagination => ({
  page,
  perPage: limit
});
